export const galleryImages = [
  {
    id: '1',
    category: 'Etkinlikler',
    title: 'Liderlik Konferansı 2024',
    date: '2024-11-15',
    image: 'https://public.readdy.ai/ai/img_res/06c9dbe5a960ad8def39b885b5a56b71.jpg'
  },
  {
    id: '2',
    category: 'Çalışmalar',
    title: 'Stratejik Planlama Toplantısı',
    date: '2024-10-20',
    image: 'https://readdy.ai/api/search-image?query=executive%20business%20meeting%20in%20modern%20boardroom%20with%20team%20discussing%20strategy%20around%20conference%20table%2C%20professional%20corporate%20environment%2C%20collaborative%20atmosphere%2C%20natural%20lighting%2C%20high%20quality%20business%20photography&width=800&height=600&seq=gallery2&orientation=landscape'
  },
  {
    id: '3',
    category: 'Basın',
    title: 'Röportaj - İş Dünyası Dergisi',
    date: '2024-09-10',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20portrait%20for%20magazine%20interview%2C%20executive%20in%20modern%20office%20setting%2C%20confident%20pose%2C%20natural%20lighting%2C%20editorial%20photography%20style%2C%20corporate%20environment%2C%20high%20quality%20professional%20headshot&width=600&height=600&seq=gallery3&orientation=squarish'
  },
  {
    id: '4',
    category: 'Etkinlikler',
    title: 'Yıllık Gala Gecesi',
    date: '2024-08-25',
    image: 'https://readdy.ai/api/search-image?query=elegant%20corporate%20gala%20event%20in%20luxury%20venue%2C%20professional%20networking%20atmosphere%2C%20formal%20business%20attire%2C%20sophisticated%20lighting%2C%20high-end%20event%20photography%2C%20prestigious%20gathering&width=800&height=600&seq=gallery4&orientation=landscape'
  },
  {
    id: '5',
    category: 'Çalışmalar',
    title: 'Proje Lansmanı',
    date: '2024-07-30',
    image: 'https://readdy.ai/api/search-image?query=modern%20product%20launch%20event%20with%20professional%20presentation%2C%20innovative%20business%20project%20reveal%2C%20contemporary%20venue%2C%20engaged%20audience%2C%20corporate%20event%20photography%2C%20exciting%20atmosphere&width=600&height=800&seq=gallery5&orientation=portrait'
  },
  {
    id: '6',
    category: 'Özel Anlar',
    title: 'Ekip Başarı Kutlaması',
    date: '2024-06-15',
    image: 'https://readdy.ai/api/search-image?query=professional%20team%20celebration%20in%20modern%20office%2C%20success%20achievement%20moment%2C%20happy%20business%20colleagues%2C%20contemporary%20workspace%2C%20natural%20lighting%2C%20authentic%20corporate%20photography&width=600&height=600&seq=gallery6&orientation=squarish'
  },
  {
    id: '7',
    category: 'Basın',
    title: 'TV Programı Konuk Konuşmacı',
    date: '2024-05-20',
    image: 'https://readdy.ai/api/search-image?query=professional%20tv%20studio%20interview%20setup%2C%20business%20leader%20as%20guest%20speaker%2C%20modern%20broadcast%20environment%2C%20professional%20lighting%2C%20media%20appearance%2C%20high%20quality%20television%20production&width=800&height=600&seq=gallery7&orientation=landscape'
  },
  {
    id: '8',
    category: 'Etkinlikler',
    title: 'Uluslararası İş Forumu',
    date: '2024-04-10',
    image: 'https://readdy.ai/api/search-image?query=international%20business%20forum%20with%20global%20executives%20networking%2C%20prestigious%20conference%20venue%2C%20professional%20corporate%20event%2C%20diverse%20business%20leaders%2C%20high-end%20event%20photography&width=600&height=800&seq=gallery8&orientation=portrait'
  },
  {
    id: '9',
    category: 'Çalışmalar',
    title: 'Mentorluk Programı',
    date: '2024-03-15',
    image: 'https://readdy.ai/api/search-image?query=professional%20mentorship%20session%20in%20modern%20office%2C%20business%20mentor%20guiding%20mentee%2C%20collaborative%20learning%20environment%2C%20contemporary%20workspace%2C%20natural%20lighting%2C%20authentic%20corporate%20photography&width=600&height=600&seq=gallery9&orientation=squarish'
  },
  {
    id: '10',
    category: 'Özel Anlar',
    title: 'Ödül Töreni',
    date: '2024-02-20',
    image: 'https://readdy.ai/api/search-image?query=prestigious%20business%20award%20ceremony%2C%20executive%20receiving%20recognition%20trophy%2C%20elegant%20event%20venue%2C%20formal%20atmosphere%2C%20professional%20event%20photography%2C%20achievement%20celebration%20moment&width=800&height=600&seq=gallery10&orientation=landscape'
  },
  {
    id: '11',
    category: 'Basın',
    title: 'Gazete Röportajı',
    date: '2024-01-25',
    image: 'https://readdy.ai/api/search-image?query=professional%20newspaper%20interview%20photoshoot%2C%20business%20executive%20portrait%20for%20press%2C%20editorial%20photography%20style%2C%20modern%20office%20background%2C%20natural%20lighting%2C%20high%20quality%20journalism%20photography&width=600&height=800&seq=gallery11&orientation=portrait'
  },
  {
    id: '12',
    category: 'Etkinlikler',
    title: 'Sektör Zirvesi Paneli',
    date: '2023-12-10',
    image: 'https://readdy.ai/api/search-image?query=industry%20summit%20panel%20discussion%20with%20business%20leaders%20on%20stage%2C%20professional%20conference%20setting%2C%20engaged%20speakers%2C%20modern%20event%20venue%2C%20corporate%20event%20photography&width=800&height=600&seq=gallery12&orientation=landscape'
  }
];

export const galleryCategories = [
  'Tümü',
  'Etkinlikler',
  'Çalışmalar',
  'Basın',
  'Özel Anlar'
];
